import React from 'react';
import Select from 'react-select';
import BaseApi from '../../../api/BaseApi.js';
import ScreenCaption from '../../screen-caption.js';


export default class ProjectProgramScreen extends React.Component {

    constructor(props) {
        super(props);

        var projectid = null;

        if (props.args.project)  {
            projectid = props.args.project
        }

        this.state = {programOptions: [], 
                      currentProgram: "",
                      currentProgramId: "",  
                      projectid: projectid,    
                      development: false}

    
        this.handleChangeProgram = this.handleChangeProgram.bind(this);
        this.handleChangeDevelopment = this.handleChangeDevelopment.bind(this);
        this.save = this.save.bind(this);                         
    }

    async componentDidMount() {
         
        BaseApi.get("/programs", {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => { 
            const programOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            this.setState({programOptions: programOptions})
        })    
        .catch()

    }


    save(event) {
        const payload = {
            projectid: this.state.projectid,
            programid: this.state.currentProgramId,
            development: this.state.development, // тут должно быть число/строка/простой JSON
        };
        BaseApi.post('/project/program/link', 
            payload,
            {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            this.props.goback(this.props.args)
        })
        .catch(error=>console.log(error))
        
        event.preventDefault();
    }

   
    handleChangeProgram(selectedOption) {
        this.setState({currentProgram: selectedOption.label, currentProgramId: selectedOption.value})
    }

    handleChangeDevelopment() {
        var development = !this.state.development
        this.setState({development: development})
    }

    render() {

        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.props.args} caption={"Программа"}/>

                <div className="row mt-4">
                    <div className="col-lg-8">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">
                                    "Добавить программу в проект"
                                </h6>
                                <form>
                                    <div class="form-group">
                                     
                                        <div class = "mb-3">
                                        <label for="program">Программа:</label>
                                        
                                        <Select options= {this.state.programOptions} 
                                                id="program" 
                                                onChange={this.handleChangeProgram}
                                                placeholder={this.state.currentProgram}    
                                                />
                                        </div> 
                                        <div class = "mb-3">     
                                            <label for="developepment">Разработка:</label>
                                            <input 
                                                type="checkbox" 
                                                id="development" 
                                                value={this.state.development}
                                                onChange={this.handleChangeDevelopment}
                                            />
                                        </div>

                    
                                        <div className="mt-4 d-flex justify-content-end">
                                            <div class="row mt-3">
                                                <button class="btn btn-primary w-100" onClick={this.save}>Сохранить</button>   
                                            </div>
                                        </div>       
                                    </div>
                                </form>

                            </div>
                        </div>

                    </div>
                </div>
            </div> 
        )
    }

}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/project/projectprogram.js